var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "newsletter-subscribe-wrapper",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#newsletter-subscribe",
        "data-load-url":
          "/mail-subscription/form/verhuurd/" + _vm.rentalShortId + "/",
        "data-load-method": "GET",
      },
      on: {
        click: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }